import Pause from '../../src/legacy/Pause';
export default Pause;
